import { QueryKey } from '@tanstack/react-query';

import { fetchWalletBalance } from '../../../services/private-area/wallet';
import { getWalletBalanceKeys } from '../query-keys';

const getWalletBalance = (options: {
  locale: string;
}): [QueryKey, () => ReturnType<typeof fetchWalletBalance>] => [
  getWalletBalanceKeys(options),
  () => fetchWalletBalance({ locale: options.locale }),
];

export default getWalletBalance;
